import { ReactNode } from 'react';
import dynamic from 'next/dynamic';

import BaseLayout from '@/components/Layout/Base';
import Footer from '@/components/Footer';
import Header from '@/components/nav';
import SEO, { SEOProps } from '@/components/SEO';

interface VanillaLayoutProps {
  children: ReactNode;
  removeSalesBreakpoint?: boolean;
  seo: SEOProps;
  preview?: boolean;
}

const DynamicPreviewBanner = dynamic(() => import(`../PreviewBanner`));

export default function VanillaLayout({
  children,
  removeSalesBreakpoint = false,
  seo,
  preview,
}: VanillaLayoutProps) {
  return (
    <BaseLayout>
      {preview && <DynamicPreviewBanner />}

      <SEO {...seo} />

      <Header />

      <div className="mt-12">
        {children}
        <Footer removeSalesBreakpoint={removeSalesBreakpoint} />
      </div>
    </BaseLayout>
  );
}
